export interface ICompsLifeCycle {
	registerToCompLifeCycle: (compIds: Array<string>, callbackName: string, callback: Function) => void
	unregisterToCompLifeCycle: (compIds: Array<string>, callbackName: string) => void
	notifyCompDidMount: (compId: string, displayedId: string) => void
}

export const CompsLifeCycleSym = Symbol.for('CompsLifeCycle')
